import ReportsShow from "components/reports/show";
import { paths } from "helpers/paths";
import { REPORT_TYPES } from "helpers/reports";
import React from "react";
import * as source from "sources/books/reports";

export default function IntersectionsReport(props) {
    const { history } = props;
    const back = () => history.push(paths.reports);
    return (
        <div className="page-content">
            <ReportsShow
                {...props}
                id={REPORT_TYPES.PlanPointIntersectionsReport}
                transition="full"
                source={source}
                back={back}
            />
        </div>
    );
}
